
import { Location } from '@angular/common';
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { ApiGateway, OrderPayDetail, PageOptions } from 'cw-backend';
import { CwUtils } from 'cw-utils';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class OrderPayDetailListProvider implements Resolve<any> {
    orderPayDetail: OrderPayDetail[];
    orderPayDetailEdit: OrderPayDetail;
    onDataChanged: BehaviorSubject<any>;
    routeParams: any;
    state: any;
    pageOptions: PageOptions;
    currentPage: PageOptions;

    constructor(
        public gw: ApiGateway,
        private location: Location,
    ) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        // Get state for current or new page
        this.state = this.location.getState();
        this.currentPage = this.state?.currentPage;
        this.orderPayDetailEdit = this.state?.currentOrderPayDetail;

        if (this.currentPage) {
            this.pageOptions = this.currentPage;
        }
        else {
            this.pageOptions = new PageOptions();
            this.pageOptions.fieldSort = 'id';
        }
        return new Promise<void>((resolve, reject) => {
            Promise.all([
                this.getPage(this.pageOptions)
            ]).then(
                () => {
                    resolve();
                },
                reject
            );
        });
    }

    get(id: number): Observable<OrderPayDetail> {
        if (!id) {
            return null;
        }
        return this.gw.get('orderPayDetail/:id', { id: id });
    }

    get currentOrderPayDetail(): OrderPayDetail {
        return this.orderPayDetailEdit;
    }

    getAll(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.get('orderPayDetail/').subscribe((res: HttpResponse<any>) => {
                this.orderPayDetail = res.body;
                resolve(res);
            }, reject);
        });

    }

    getPage(pageOptions: PageOptions, orderId?: number): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post(`/order/pays/${orderId}`, pageOptions).subscribe((res: HttpResponse<any>) => {
                if (!CwUtils.compare(this.orderPayDetail, res.body.content) && res.body.content.length > 0) {
                    this.orderPayDetail = res.body.content;
                    this.onDataChanged.next(this.orderPayDetail);
                }
                else {
                    this.orderPayDetail = res.body.content;
                };
                resolve(res);
            }, reject);
        });
    }

    getPageSettings() {
        if (this.currentPage) {
            return this.pageOptions;
        } else {
            return;
        }
    }
}

